// extracted by mini-css-extract-plugin
export default {"reasonLink":"DisputeReasonCell_reasonLink__o+S5Q"};